<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <v-card class="mb-3">
            <div class="pa-3">
                <v-row>
                    <v-col cols="12">
                        <h3>เพิ่ม Lot เข้าคลังจากใบสั่งซื้อ</h3>
                        <div class="d-flex align-center title_search_add_lotin_po_list">
                            <div>ใบสั่งซื้อ</div>
                            <div class="ml-2">
                                <v-select :items="number_purchase_order_list" item-text="po_no" item-value="id" hide-details="auto" @change="selectNumberPurchaseOrderList" dense outlined>
                                </v-select>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-card>
        <v-card v-if="detail_page === true">
            <div v-if="loading_detail_page === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <div class="pa-3" v-if="loading_detail_page === false">
                <v-row>
                    <v-col cols="12">
                        <v-tabs grow>
                            <v-tab @click="page(source_detail.purchase_order_id)" v-for="(source_detail,index) in source_list" :key="index">{{ source_detail.source_name }}</v-tab>
                        </v-tabs>
                        <div class="mt-2">
                            <v-form ref="form_add" @submit.prevent="addLotinPo()">
                                <div v-for="(purchase_order_detail,index) in purchase_order_list" :key="index">
                                    <v-simple-table v-if="page_id == purchase_order_detail.purchase_order_id">
                                        <thead>
                                            <tr>
                                                <th class="text-center border_header_add_lotin_po_list">
                                                    #
                                                </th>
                                                <th class="text-center border_header_add_lotin_po_list">
                                                    วัตถุดิบ
                                                </th>
                                                <th class="text-center border_header_add_lotin_po_list">
                                                    จำนวน
                                                </th>
                                                <th class="text-center border_header_add_lotin_po_list">
                                                    หน่วยนับ
                                                </th>
                                                <th class="text-center border_header_add_lotin_po_list">
                                                    ราคาต่อหน่วย
                                                </th>
                                                <th class="text-center border_header_add_lotin_po_list">
                                                    สรุปรายการ (บาท)
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="(purchase_order_type_detail,index_type) in purchase_order_detail.typeList" :key="index_type">
                                            <tr>
                                                <td colspan="6" class="primary white--text">
                                                    {{ purchase_order_type_detail.type_name }}
                                                </td>
                                            </tr>
                                            <tr v-for="(purchase_order_detail_detail,index_detail) in purchase_order_type_detail.detailList" :key="index_detail">
                                                <td class="text-center border_header_add_lotin_po_list" width="5%">{{ index_detail + 1 }}</td>
                                                <td class="text-center border_header_add_lotin_po_list" width="30%">{{ purchase_order_detail_detail.mat_name }}</td>
                                                <td class="text-center border_header_add_lotin_po_list" width="10%">
                                                    <v-text-field hide-details="auto" type="number" @keypress="isNumberPrice($event)" onpaste="return false" v-model="purchase_order_detail_detail.quantity" :rules="[v => !!v || 'กรุณากรอกจำนวน']" required dense outlined></v-text-field>
                                                </td>
                                                <td class="text-center border_header_add_lotin_po_list" width="10%">
                                                    <v-select v-model="purchase_order_detail_detail.unit_type" :items="purchase_order_detail_detail.unit_type_list" item-text="unit_type_name" item-value="id" hide-details="auto" dense outlined>
                                                    </v-select>
                                                </td>
                                                <td class="text-center border_header_add_lotin_po_list" width="25%">
                                                    <v-text-field hide-details="auto" type="number" @keypress="isNumberPrice($event)" onpaste="return false" v-model="purchase_order_detail_detail.price" :rules="[v => !!v || 'กรุณากรอกราคาต่อหน่วย']" required dense outlined v-if="purchase_order_detail_detail.unit_type == 1"></v-text-field>
                                                    <v-text-field hide-details="auto" type="number" @keypress="isNumberPrice($event)" onpaste="return false" v-model="purchase_order_detail_detail.price_other" :rules="[v => !!v || 'กรุณากรอกราคาต่อหน่วย']" required dense outlined v-if="purchase_order_detail_detail.unit_type == 2"></v-text-field>
                                                </td>
                                                <td class="text-center border_header_add_lotin_po_list" width="20%">
                                                    {{ purchase_order_detail_detail.unit_type == 1 && purchase_order_detail_detail.quantity ? currencyFormat(purchase_order_detail_detail.quantity * purchase_order_detail_detail.price) :  purchase_order_detail_detail.unit_type == 2 && purchase_order_detail_detail.quantity ? currencyFormat(purchase_order_detail_detail.quantity * purchase_order_detail_detail.price_other) : '' }}
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody>
                                            <tr>
                                                <td class="text-center border_header_add_lotin_po_list pt-2 pb-2" colspan="6">
                                                    <v-btn color="#28ab28" type="submit" class="white--text" width="20%" height="50">
                                                        บันทึก
                                                    </v-btn>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </v-simple-table>
                                </div>
                            </v-form>
                        </div>
                    </v-col>
                </v-row>
            </div>
            <v-dialog v-model="open_alert_show_add" persistent max-width="600">
                <v-card>
                    <v-card-title>
                        สำเร็จ
                    </v-card-title>

                    <v-card-text>
                        เพิ่มวัตถุดิบจากใบสั่งซื้อเรียบร้อย
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" text @click="confirmSuccess()">
                            ตกลง
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </div>
</div>
</template>

<script>
import numberpurchaseorder from '@/api/stock/stocklist/numberpurchaseorder.js'
import {
    currencyFormat
} from '@/helper/numberformat.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            loading_detail_page: true,
            detail_page: false,
            open_alert_show_add: false,
            number_purchase_order_list: [],
            page_id: null,
            refer_id: null,
            source_list: [],
            purchase_order_list: [],
        }
    },
    methods: {
        currencyFormat,
        async isNumberPrice(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async numberPurchaseOrderList() {
            this.loading_page = true
            this.number_purchase_order_list = []
            numberpurchaseorder.numberPurchaseOrderList().then((response) => {
                if (response.data.successful === true) {
                    this.number_purchase_order_list = response.data.list
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async selectNumberPurchaseOrderList(id) {
            this.detail_page = true
            this.loading_detail_page = true
            this.page_id = null
            this.refer_id = null
            this.source_list = []
            numberpurchaseorder.inventoryPurchaseOrderList(id).then((response) => {
                if (response.data.successful === true) {
                    this.refer_id = id
                    response.data.sourceList.forEach((detail, index) => {
                        if (index == 0) {
                            this.page_id = detail.purchase_order_id
                        }
                        this.source_list.push({
                            purchase_order_id: detail.purchase_order_id,
                            source_name: detail.source_name,
                        })
                    })
                    this.purchase_order_list = response.data.sourceList
                    response.data.sourceList.forEach((type_list, index_source) => {
                        type_list.typeList.forEach((detail_list, index_type) => {
                            detail_list.detailList.forEach((detail, index) => {
                                this.purchase_order_list[index_source]['typeList'][index_type]['detailList'][index]['unit_type_list'] = [{
                                    id: 1,
                                    unit_type: detail.unit_id,
                                    unit_type_name: detail.unit_name,
                                }, ]
                                if (detail.unit_other_id) {
                                    this.purchase_order_list[index_source]['typeList'][index_type]['detailList'][index]['unit_type_list'] = [{
                                            id: 1,
                                            unit_type: detail.unit_id,
                                            unit_type_name: detail.unit_name,
                                        },
                                        {
                                            id: 2,
                                            unit_type: detail.unit_other_id,
                                            unit_type_name: detail.unit_other_name,
                                        }
                                    ]
                                }
                            })
                        })
                    })
                    this.loading_detail_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async page(id) {
            this.page_id = id
        },
        async addLotinPo() {
            if (this.$refs.form_add.validate()) {
                this.loading_page = true
                const mat_id = this.purchase_order_list.map((source_list) =>
                    source_list.typeList.map((type_list) =>
                        type_list.detailList.map((detail_list) => {
                            return detail_list.id
                        })
                    )
                )
                const quantity = this.purchase_order_list.map((source_list) =>
                    source_list.typeList.map((type_list) =>
                        type_list.detailList.map((detail_list) => {
                            return parseFloat(detail_list.quantity)
                        })
                    )
                )
                const unit_id = this.purchase_order_list.map((source_list) =>
                    source_list.typeList.map((type_list) =>
                        type_list.detailList.map((detail_list) => {
                            if (detail_list.unit_type == 1) {
                                return detail_list.unit_type_list[0].unit_type
                            } else {
                                return detail_list.unit_type_list[1].unit_type
                            }
                        })
                    )
                )
                const unit_type = this.purchase_order_list.map((source_list) =>
                    source_list.typeList.map((type_list) =>
                        type_list.detailList.map((detail_list) => {
                            return detail_list.unit_type
                        })
                    )
                )
                const price = this.purchase_order_list.map((source_list) =>
                    source_list.typeList.map((type_list) =>
                        type_list.detailList.map((detail_list) => {
                            if (detail_list.unit_type == 1) {
                                return parseFloat(detail_list.price)
                            } else {
                                return parseFloat(detail_list.price_other)
                            }
                        })
                    )
                )
                const total = this.purchase_order_list.map((source_list) =>
                    source_list.typeList.map((type_list) =>
                        type_list.detailList.map((detail_list) => {
                            if (detail_list.unit_type == 1) {
                                return parseFloat(detail_list.quantity) * parseFloat(detail_list.price)
                            } else {
                                return parseFloat(detail_list.quantity) * parseFloat(detail_list.price_other)
                            }
                            
                        })
                    )
                )
                let total_source = [] 
                this.purchase_order_list.forEach((source_list) => {
                    let price = 0
                    source_list.typeList.forEach((type_list) =>
                        type_list.detailList.forEach((detail_list) => {
                            if (detail_list.unit_type == 1) {
                                price += parseFloat(detail_list.quantity) * parseFloat(detail_list.price)
                            } else {
                                price += parseFloat(detail_list.quantity) * parseFloat(detail_list.price_other)
                            }
                            
                        })
                    )
                    total_source.push({
                        source_name: source_list.source_name,
                        source_price: price,
                    })
                })
                const data = {
                    refer_id: this.refer_id,
                    mat_id: mat_id.flat(Infinity),
                    quantity: quantity.flat(Infinity),
                    unit_id: unit_id.flat(Infinity),
                    unit_type: unit_type.flat(Infinity),
                    price: price.flat(Infinity),
                    total: total.flat(Infinity),
                    total_price: total.flat(Infinity).reduce((sum, number) => {
                        return sum + parseFloat(number)
                    }, 0),
                    total_source: total_source,
                }

                numberpurchaseorder.addMaterialPurchaseOrder(data).then((response) => {
                    if (response.data.successful === true) {
                        this.open_alert_show_add = true
                        this.loading_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            }
        },
        async confirmSuccess() {
            this.$router.push('/stockinout')
        },
    },
    mounted() {
        this.numberPurchaseOrderList()
    }
}
</script>

<style scoped>
.title_search_add_lotin_po_list>div:last-child {
    width: 30%;
}

.border_header_add_lotin_po_list {
    border: thin solid rgba(0, 0, 0, 0.12);
}
</style>
